import { render, staticRenderFns } from "./pref-information-list.vue?vue&type=template&id=f7d22b7a&"
import script from "./pref-information-list.vue?vue&type=script&lang=js&"
export * from "./pref-information-list.vue?vue&type=script&lang=js&"
import style0 from "./pref-information-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports